import { Tabs } from "@commonlibs";
import { RouterTabsProps } from "./RouterTabs.types";

const RouterTabs = (props: RouterTabsProps): JSX.Element => <Tabs {...props} />;

export default RouterTabs;
